import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

const Wrapper = styled.section`
  margin-bottom: 80px;
  position: relative;
  color: white;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  padding: 0 0 40px;
  margin-top: 150px;

  ${media.lg`
    padding: 60px 0;
    margin-top: 0;
  `}
`

const Image = styled.div`
  width: calc(100% - 15px);
  display: block;
  margin-top: -75px;
  margin-bottom: 50px;
  transform: translateX(30px);
  background: url(${props => props.image}) center / cover;
  height: 0;
  padding-bottom: 51%;

  ${media.lg`
    transform: translateX(0);
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-bottom: 0;
  `}
`

const Header = styled.h2`
  font-family: ${props => props.theme.displayFont};
  color: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
  font-weight: 600;
  line-height: 38px;
  padding-left: 30px;
  font-size: 32px;

  ${media.lg`
    padding-left: 0;
    font-size: 45px;
    line-height: 40px;
  `}
`

const Body = styled.div`
  font-size: 16px;
  line-height: 21px;
  color: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.grey.darkest};
  padding-left: 30px;

  a {
    color: inherit;
    text-decoration: underline;
  }

  ${media.xs`
    padding: 0 30px;
  `}

  ${media.lg`
    padding-left: 0;
  `}
`

const Button = styled(Link)`
  padding: 12px 15px;
  border: 1px solid ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
  text-transform: uppercase;
  color: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.0117em;
  margin-top: 40px;
  display: inline-block;
  font-family: ${props => props.theme.bodyFont};
  margin-left: 30px;

  svg {
    display: inline-block;
    margin-left: 85px;
    transition: transform 0.3s ${easing.easeOutCubic};

    path {
      fill: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
    }
  }

  &:hover svg {
    transform: translateX(25%);
  }

  ${media.lg`
    margin-left: 0;
  `}
`

const ExternalButton = styled.a`
  padding: 12px 15px;
  border: 1px solid ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
  text-transform: uppercase;
  color: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.0117em;
  margin-top: 40px;
  display: inline-block;
  font-family: ${props => props.theme.bodyFont};
  margin-left: 30px;

  svg {
    display: inline-block;
    margin-left: 85px;
    transition: transform 0.3s ${easing.easeOutCubic};

    path {
      fill: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.grey.lightest : props.theme.colors.theme.base};
    }
  }

  &:hover svg {
    transform: translateX(25%);
  }

  ${media.lg`
    margin-left: 0;
  `}
`

const Background = styled.div`
  position: absolute;
  width: calc(100% - 15px);
  background: ${props => props.theme.colors.theme.base === props.theme.colors.oxford.base ? props.theme.colors.oxford.base : props.theme.colors.grey.lightest};
  height: 100%;
  z-index: 0;
  right: 0;
  top: 0;

  ${props => props.orientation === 'right' ? 'left: 0;' : 'right: 0;'}

  ${media.lg`
    width: calc(((100% - 100px) * 0.91666667) + 50px);
  `}
`

class ImageAndText extends Component {
  render() {
    const {
      orientation,
      header,
      body,
      link,
      image,
      externalLink,
    } = this.props

    return (
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
          <Container fluid style={{zIndex: 1, position: 'relative'}}>
            <Row>
              <Col
                lg={4}
                order="last"
                lgOrder={orientation === 'right' ? 'first' : 'last'}
                lgOffset={1}
              >
                {header &&
                  <Header>{header}</Header>
                }
                <Body dangerouslySetInnerHTML={{ __html: body }} />
                {link.url ? (externalLink ? (
                  <ExternalButton href={link.url} target="_blank">
                    <span>{link.title}</span>
                    <svg width="14" height="12" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        d="M8.2141479 11.849602C8.0944187 11.9684 8.001699 12 7.8501226 12H7.200481c-.2719103 0-.3339922-.193197-.151375-.374394l5.1590377-5.118914H.3023464C.1058212 6.506692 0 6.401693 0 6.206697v-.413394c0-.194996.1058212-.299995.3023464-.299995h11.9057973L7.049106.374394C6.8664888.193197 6.9285707 0 7.2006825 0h.6496415c.1515765 0 .2575992.044999.3638236.150398l5.6835081 5.639306c.1364591.135397.1364591.285195 0 .420593l-5.6835081 5.639306 3e-7-.000001z"
                      />
                    </svg>
                  </ExternalButton>
                ) : (
                  <Button to={getRelativeUrl(link.url)}>
                    <span>{link.title}</span>
                    <svg width="14" height="12" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        d="M8.2141479 11.849602C8.0944187 11.9684 8.001699 12 7.8501226 12H7.200481c-.2719103 0-.3339922-.193197-.151375-.374394l5.1590377-5.118914H.3023464C.1058212 6.506692 0 6.401693 0 6.206697v-.413394c0-.194996.1058212-.299995.3023464-.299995h11.9057973L7.049106.374394C6.8664888.193197 6.9285707 0 7.2006825 0h.6496415c.1515765 0 .2575992.044999.3638236.150398l5.6835081 5.639306c.1364591.135397.1364591.285195 0 .420593l-5.6835081 5.639306 3e-7-.000001z"
                      />
                    </svg>
                  </Button>
                )) : null}
              </Col>
              <Col
                lg={6}
                lgOffset={orientation === 'right' ? 1 : 0}
              >
                <Image image={image.sourceUrl} />
              </Col>
            </Row>
          </Container>
          <Background orientation={orientation} />
        </Wrapper>
      </InViewMonitor>
    )
  }
}

export default ImageAndText



// WEBPACK FOOTER //
// ./src/ui/components/modules/ImageAndText/index.js